/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationDto } from './locationDto';


export interface LocationDtoPagedResultDto { 
    items?: Array<LocationDto> | null;
    totalCount?: number;
}

